import {
  RelatorioIdEnum,
  FieldRelatorioColumn,
} from "core/features/relatorios/typings";
import {
  fieldsRelatorioReceitasOptions,
  fieldsRelatorioDespesaColumns,
  fieldsRelatorioContasComComposicaoColumns,
  fieldsRelatorioInadimplentesColumns,
} from "core/features/relatorios/typings";

export default function getColunasFormConfiguracaoAdicional(
  relatorioId?: RelatorioIdEnum | null
): { header: string; items: FieldRelatorioColumn[] }[] | undefined {
  if (relatorioId === RelatorioIdEnum.Receitas) {
    return [
      {
        header: "",
        items: fieldsRelatorioReceitasOptions.slice(0, 3),
      },
      {
        header: "",
        items: fieldsRelatorioReceitasOptions.slice(3),
      },
    ];
  } else if (relatorioId === RelatorioIdEnum.TotalDeDespesas) {
    return [
      {
        header: "",
        items: fieldsRelatorioDespesaColumns.slice(0, 3),
      },
      {
        header: "",
        items: fieldsRelatorioDespesaColumns.slice(3),
      },
    ];
  } else if (
    relatorioId &&
    [
      RelatorioIdEnum.ReceitasComComposicao,
      RelatorioIdEnum.DespesasComComposicao,
    ].includes(relatorioId)
  ) {
    return [
      {
        header: "",
        items: fieldsRelatorioContasComComposicaoColumns.slice(0, 5),
      },
      {
        header: "",
        items: fieldsRelatorioContasComComposicaoColumns.slice(5),
      },
    ];
  } else if (
    relatorioId &&
    [RelatorioIdEnum.Inadimplentes].includes(relatorioId)
  ) {
    return [
      {
        header: "",
        items: fieldsRelatorioInadimplentesColumns.slice(0, 6),
      },
      {
        header: "",
        items: fieldsRelatorioInadimplentesColumns.slice(6),
      },
    ];
  }

  return undefined;
}
